import { render, staticRenderFns } from "./SubstationCostsChart.vue?vue&type=template&id=2248a8d6&"
import script from "./SubstationCostsChart.vue?vue&type=script&lang=js&"
export * from "./SubstationCostsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports